
<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
      </p>
        <h1 v-translate>Vytvořit inicializační proces zařízení</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
            <basic-settings
                :is-update="false"
                :entity="entity"
                :is-editable="true"
                :brand-options="brandOptions"
                :device-type-options="deviceTypeOptions"
                ref="basicsettingsref"
            ></basic-settings>
          <welcome-screen-settings
              :entity="entity"
              :keys-options="this.keysOptions"
              :is-editable="true"
              ref="welcomescreensettingsref"
          >
          </welcome-screen-settings>
          <default-pairing-screen
              :entity="entity"
              :is-editable="true"
              ref="defaultpairingscreenref"
          >
          </default-pairing-screen>
          <failed-pairing-screen
              :entity="entity"
              :is-editable="true"
              ref="failedpairingscreenref"
          >
          </failed-pairing-screen>
          <promo-screen
              :entity="entity"
              :is-editable="true"
              ref="promoscreenref"
          />
          <languages
              :entity="entity"
              :is-editable="true"
              :language-options="languageOptions"
              ref="promoscreenref"
          />
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="$_createActionAllowed"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import detailActions from "../../../components/mixins/detail-actions"
import initialProcessSetup from "./mixins/InitialProcessSetup";
import BasicSettings from "./forms/BasicSettings.vue";
import WelcomeScreenSettings from "./forms/WelcomeScreenSettings.vue";
import DefaultPairingScreen from "./forms/DefaultPairingScreen.vue";
import FailedPairingScreen from "./forms/FailedPairingScreen.vue";
import PromoScreen from "./forms/PromoScreen.vue";
import Languages from "./forms/Languages.vue";

export default {
  name: "InitialProcessSetupNew",
  data(){
    return {
      detailPageRouteName: "initialProcessSetupDetail"
    }
  },
  components: {Languages, PromoScreen, FailedPairingScreen, DefaultPairingScreen, WelcomeScreenSettings, BasicSettings},
  mixins: [detailActions, initialProcessSetup],
  created(InitialProcessSetupService, DeviceTypeService, BrandService) {
    this.entityService = InitialProcessSetupService;
    this.deviceTypeService = DeviceTypeService;
    this.brandService = BrandService;
    this.getBrands();
    this.getDeviceTypes();
    this.getSettings();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/InitialProcessSetupNew.vue